import React from "react";
import { ShoppingCart, X, Plus } from "lucide-react";

const ItemRow = ({
  item,
  isPick5Filter,
  prices,
  isLoadingPrices,
  isInCart,
  onAddToCart,
  onRemoveFromCart,
  onCategoryClick,
  getItemQuantity
}) => {
  const handleAddToCart = (e) => {
    e.stopPropagation();
    onAddToCart({
      ...item,
      title: isPick5Filter ? `${item.title} Pick 5` : item.title,
      price: prices[item.id] || item.price,
    });
  };

  const handleRemoveFromCart = (e) => {
    e.stopPropagation();
    onRemoveFromCart(item.id);
  };

  const getPrice = () => {
    if (isPick5Filter) return " 5 for $250.00";
    if (isLoadingPrices) return "Loading...";
    return `$${Number(prices[item.id] || item.price || 0).toFixed(2)}`;
  };

  const quantity = getItemQuantity(item.id) || 0;

  return (
    <div className="item-row">
      <div className="row-image">
        <img
          src={item.images[0]}
          alt={item.title}
          onError={(e) => (e.target.src = "/img/datlogoA.png")}
        />
      </div>
      <div className="row-content">
        <div className="row-header">
          <h2>{item.title}</h2>
          {quantity > 0 ? (
            <div className="cart-controls">
              <button
                className="add-another-btn"
                onClick={handleAddToCart}
                title="Add another"
              >
                <Plus size={16} />
              </button>
              <span className="quantity-badge">{quantity}</span>
              <button
                className="remove-all-btn"
                onClick={handleRemoveFromCart}
                title="Remove all"
              >
                <X size={16} />
              </button>
            </div>
          ) : (
            <button
              className="add-to-cart-btn"
              onClick={handleAddToCart}
            >
              <ShoppingCart size={20} /> Add to Cart -{getPrice()}
            </button>
          )}
        </div>
        <div className="row-categories">
          {item.category.split(",").map((cat, i) => (
            <span
              key={i}
              className="category-tag"
              onClick={() => onCategoryClick(cat.trim())}
            >
              {cat.trim()}
            </span>
          ))}
        </div>
        <div
          className="row-description"
          dangerouslySetInnerHTML={{ __html: item.description }}
        />
        <div className="row-gallery-wrapper">
          <div className="row-gallery">
            {item.images.slice(1).map((img, i) => (
              <img
                key={i}
                src={img}
                alt={`${item.title} ${i + 1}`}
                onError={(e) => (e.target.src = "/img/datlogoA.png")}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemRow;
